import React from 'react';
import { LocaleContext } from '../locale-context';
import en from '../locales/en.json';
import ro from '../locales/ro.json';

const langs = {
    en,
    ro
};

const getBase64OrDefault = image =>
    image ? image : require('../images/facePlaceholder.jpg');

const Testimonial = ({ testimonial }) => (
    <div className="testimonial-component">
        <figure className="testimonial-component-shape">
            <img
                src={getBase64OrDefault(testimonial['imageBase64'])}
                className="testimonial-component-img"
            />
            <figcaption className="testimonial-component-caption">
                {testimonial['role']}
            </figcaption>
        </figure>
        <div className="testimonial-component-text">
            <h3 className="testimonial-component-heading">
                {testimonial['name']}
            </h3>
            <p>{testimonial['statement']}</p>
            <span>{testimonial['website']}</span>
        </div>
    </div>
);

const TranslatedComponent = props => (
    <React.Fragment>
        <section className="cover cover-middle">
            <div className="text-box">
                <h1 className="heading-primary">
                    <span className="heading-primary-main testimonials">
                        Testimonials
                    </span>
                </h1>
            </div>
        </section>
        <div className="testimonial-section">
            <LocaleContext.Consumer>
                {value =>
                    langs[value]['testimonials'].map((testimonial, index) => (
                        <Testimonial key={index} testimonial={testimonial} />
                    ))
                }
            </LocaleContext.Consumer>
        </div>
    </React.Fragment>
);

export default TranslatedComponent;



// WEBPACK FOOTER //
// ./src/components/Testimonials.js